<template>
  <div class="share-tip-mask" v-if="visible" @click="handleClose">
    <div class="share-tip-content" @click.stop>
      <div class="share-tip-header">
        <span>分享到朋友</span>
        <i class="fa-solid fa-xmark" @click="handleClose"></i>
      </div>
      <div class="share-tip-arrow">
        <i class="fa-solid fa-arrow-up"></i>
      </div>
      <div class="share-tip-hint">
        <p>点击右上角 <i class="fa-solid fa-ellipsis"></i></p>
        <p>选择「发送给朋友」或「分享到朋友圈」</p>
      </div>
      <div class="share-tip-btn" @click="handleClose">
        <span>我知道了</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareTip',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.share-tip-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  z-index: 9998;
  padding: 20px;
  padding-top: 60px;
}

.share-tip-content {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  width: 260px;
}

.share-tip-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.share-tip-header span {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.share-tip-header i {
  font-size: 20px;
  color: #999;
  cursor: pointer;
}

.share-tip-arrow {
  text-align: right;
  margin-bottom: 10px;
}

.share-tip-arrow i {
  font-size: 40px;
  color: #fff;
  animation: bounce 1s ease-in-out infinite;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.share-tip-hint {
  text-align: center;
  margin-bottom: 20px;
}

.share-tip-hint p {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}

.share-tip-hint i {
  color: #07c160;
  margin: 0 4px;
}

.share-tip-btn {
  background: #07c160;
  color: #fff;
  text-align: center;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.share-tip-btn:active {
  background: #06ad56;
}
</style>
